import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import Iconify from 'src/components/iconify';
import { CaySam, CaySamNhatKy } from 'src/types/caysam';
import { OptionModel } from 'src/types/api-response';
import { useTheme } from '@mui/material/styles';
import { useResponsive } from 'src/hooks/use-responsive';

type Props = {
  positionLabel: string;  
  caySam?: CaySam | null;
  latestNhatKy?: CaySamNhatKy | null;
  tuoiOptions?: OptionModel[];
  tinhTrangOptions?: OptionModel[];
  size?: 'xs' | 'sm' | 'md';
  center?: boolean;
};

export default function GinsengCellInfoMini({
  positionLabel,
  caySam,
  latestNhatKy,
  tuoiOptions = [],
  tinhTrangOptions = [],
  size = 'sm',
  center = true,
}: Props) {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'md');
  const fontMap: Record<'xs' | 'sm' | 'md', number> = { xs: 10, sm: 12, md: 14 };
  const iconMap: Record<'xs' | 'sm' | 'md', number> = { xs: 24, sm: 24, md: 24 };
  const font = fontMap[size];
  const icon = iconMap[size];
  const gap = size === 'xs' ? 0.5 : 1; 
  const getDiemSKColor = (trangThaiId: number) => {
    switch (trangThaiId) {
      case 5:
        return theme.palette.success.darker; // Rất tốt
      case 4:
        return theme.palette.success.main; // Khá tốt
      case 3: 
        return theme.palette.success.light; // Trung Bình
        case 2: 
        return theme.palette.error.light; // Yếu
        case 1:
        return theme.palette.error.main; // Rất yếu 
      default:
        return theme.palette.grey[50]; // Mặc định cho trạng thái không xác định
    }
  }
  const getText = (opts: OptionModel[], v?: number | string | null) =>
    opts.find((o) => String(o.value) === String(v))?.text || (v != null ? String(v) : '-');

  // Icon tuổi: lấy theo tuoiCay_ID (giới hạn 1-4) => /assets/icons/sam/{n}.png
  const ageIndex = (() => {
    const raw = Number(caySam?.tuoiCay_ID);
    if (Number.isFinite(raw) && raw > 0) return Math.max(1, Math.min(4, Math.trunc(raw)));
    return 1;
  })();
  const ageIconSrc = `/assets/icons/sam/${ageIndex}.png`;

  // Điều chỉnh kích thước icon cho mobile
  const iconSize = isMobile ? Math.max(12, icon - 8) : icon + 6;

  return (
    <Stack spacing={0.5} sx={{ textAlign: center ? 'center' : 'left' }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              width: iconSize,
              height: iconSize,
              mb: 0.25,
              bgcolor: getDiemSKColor(latestNhatKy?.diemSucKhoe ?? 0),
              WebkitMaskImage: `url(${ageIconSrc})`,
              maskImage: `url(${ageIconSrc})`,
              WebkitMaskRepeat: 'no-repeat', 
              maskRepeat: 'no-repeat', 
              WebkitMaskPosition: 'center',
              maskPosition: 'center',
              WebkitMaskSize: 'contain',   
              maskSize: 'contain', 
            }}
          />
        </Box> */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: center ? 'center' : 'flex-start', gap }}>
        <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: font }}>
          {positionLabel}
        </Typography>  
      </Box>
 
      {/* <Typography variant="caption" sx={{ fontSize: font, color: 'text.secondary' }}>
        Mã: {caySam?.maCaySam || '-'} 
      </Typography> */}
 
    </Stack>
  );
}
